import queryString from 'query-string';

const BASE_URL = process.env.REACT_APP_API_URL;

export function fetchSources() {
  return fetch(`${BASE_URL}/api/sources`, {
    accept: 'application/json'
  }).then(response => response.json());
}

export function fetchCategories() {
  return fetch(`${BASE_URL}/api/umbo_categories`, {
    accept: 'application/json'
  }).then(response => response.json());
}

// export function fetchCameras() {
//   return fetch(`${BASE_URL}/api/cameras`, {
//     accept: 'application/json'
//   }).then(response => response.json());
// }

export function fetchBatches() {
  return fetch(`${BASE_URL}/api/batches`, {
    accept: 'application/json'
  }).then(response => response.json());
}

export function fetchImage(imageSN) {
  return fetch(`${BASE_URL}/api/images/${imageSN}`, {
    accept: 'application/json'
  })
    .then(response => response.json())
    .then((r) => {
      console.log(r);
      return r;
    });
}

export function fetchImages(queryObject) {
  return fetch(`${BASE_URL}/api/images?${queryString.stringify(queryObject)}`, {
    accept: 'application/json'
  }).then(response => response.json());
}

export function fetchInstances(imageSN) {
  const queryObject = { image_sn: imageSN };
  return fetch(`${BASE_URL}/api/instances?${queryString.stringify(queryObject)}`, {
    accept: 'application/json'
  }).then(response => response.json());
}

export function fetchEvaluatedInstance(payload) {
  const { imageSn, modelSn } = payload;
  const queryObject = { image_sn: imageSn, model_sn: modelSn };

  return fetch(`${BASE_URL}/api/eval_instances?${queryString.stringify(queryObject)}`, {
    accept: 'application/json'
  }).then(response => response.json());
}

export function fetchModels() {
  return fetch(`${BASE_URL}/api/models`, {
    accept: 'application/json'
  }).then(response => response.json());
}

export function fetchMetrics(queryObject) {
  return fetch(`${BASE_URL}/api/metrics?${queryString.stringify(queryObject)}`, {
    accept: 'application/json'
    // mode: 'no-cors'
  }).then(response => response.json());
}



// WEBPACK FOOTER //
// ./src/api/searchFieldsAPI.js